import { Tooltip } from '@mantine/core';
import { IconPencilOff } from '@tabler/icons-react';

interface NotEditableProps {
  tooltip: string;
}

export function NotEditable({ tooltip }: NotEditableProps) {
  return (
    <Tooltip label={tooltip}>
      <div>
        <IconPencilOff size="25px" />
      </div>
    </Tooltip>
  );
}
